import { render, staticRenderFns } from "./open-closed-incidents.vue?vue&type=template&id=92657482"
import script from "./open-closed-incidents.vue?vue&type=script&lang=js"
export * from "./open-closed-incidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports